/**
 * @fileOverView
 * @description Single Vyb Page View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var VybPageTemplate = require('../../templates/pages/vybpage.html');
var AmpersandView = require('ampersand-view');
var HeaderView = require('../widgets/header');
var FooterView = require('../widgets/footer');
var VybFollowingView = require('../widgets/vybfollowingview');
var VybFollowing = require("../../models/vybfollowing");
var app = require('ampersand-app');

var VybFollowingPageView = AmpersandView.extend({

    initialize: function(options){
        if(!this.model) this.model = options.model ? options.model : new VybFollowing();
        if(options.soundKey!=undefined) this.model.soundKey = options.soundKey;
        app.vybfollowing = this.model;
        this.action = options.action != undefined ? options.action : null;
    },

    template : VybPageTemplate,

    pageName: "VybFollowingPage",

    subviews: {
        mpheader: {
            selector : 'header',
            prepareView: function(el) {
                app.currentPageName = this.pageName;
                return new HeaderView({
                    el: el,
                    parent: this,
                    model: this.model,
                    maintitle: 'Vybit Following'
                });
            }
        },

        mpfooter: {
            selector : 'footer',
            prepareView: function(el) {
                return new FooterView({
                    el: el,
                    parent: this
                });
            }
        },

        vybfollowing: {
            selector : '#content',
            prepareView: function(el) {
                return new VybFollowingView({
                    el: el,
                    parent: this,
                    model: this.model
                });
            }
        }
    }
});

module.exports = VybFollowingPageView;
